// extracted by mini-css-extract-plugin
module.exports = {"text-lockup":"text-lockup_component_text-lockup__uK6jg","pb-none":"text-lockup_component_pb-none__GDqji"};